import { render, staticRenderFns } from "./CultureActivityInfo.vue?vue&type=template&id=414a1c22&scoped=true&"
import script from "./CultureActivityInfo.vue?vue&type=script&lang=js&"
export * from "./CultureActivityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414a1c22",
  null
  
)

export default component.exports